import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText
} from "material-ui";
import { FormHelperText } from "material-ui";

class SelectComponent extends Component {
    render() {
        const {
            classes,
            error,
            multiple,
            id,
            label,
            disabled,
            fieldName,
            fieldValue,
            items,
            value,
            name,
            defaultValue
        } = this.props;
        return (
            <FormControl
                className={classes.formControl}
                disabled={disabled}
                error={error && error !== "" ? true : false}>
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Select
                    multiple={multiple}
                    value={value}
                    onChange={this.props.setValue}
                    renderValue={selected => {
                        if (multiple) {
                            return selected
                                .map(value => {
                                    let selectedItem = items.find(item => {
                                        return item[fieldValue] === value;
                                    });
                                    return selectedItem[fieldName];
                                })
                                .join(", ");
                        } else {
                            let selectedItem = items.find(item => {
                                return item[fieldValue] === selected;
                            });
                            if (selectedItem) return selectedItem[fieldName];
                            else return defaultValue || label;
                        }
                    }}
                    inputProps={{
                        name: name,
                        id: id
                    }}>
                    {multiple !== true && (
                        <MenuItem value="-1">
                            <em>{defaultValue || label}</em>
                        </MenuItem>
                    )}
                    {this.props.items.map(item => {
                        if (multiple === true) {
                            return (
                                <MenuItem
                                    key={id + "_" + item[fieldValue]}
                                    value={item[fieldValue]}>
                                    <Checkbox checked={value.indexOf(item[fieldValue]) > -1} />
                                    <ListItemText primary={item[fieldName]} />
                                </MenuItem>
                            );
                        } else
                            return (
                                <MenuItem
                                    key={id + "_" + item[fieldValue]}
                                    value={item[fieldValue]}>
                                    {item[fieldName]}
                                </MenuItem>
                            );
                    })}
                </Select>
                {error && error !== "" && <FormHelperText>{error}</FormHelperText>}
            </FormControl>
        );
    }
}

const styles = theme => ({
    formControl: {
        margin: theme.spacing.unit,
        width: "100%",
        marginBottom: "0"
    }
});

export default withStyles(styles)(SelectComponent);



// WEBPACK FOOTER //
// ./src/components/displayComponents/SelectComponent.js